var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"d-flex"},[_c('Main'),_c('Sidebar',{staticClass:"d-none d-lg-block"})],1),_c('PriceModal',{staticClass:"d-lg-none"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }